// extracted by mini-css-extract-plugin
module.exports = {"Hidden":"Hidden--UlfbE","Icon":"Icon--39jN-"};